<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
<button *ngIf="Pwa.promptEvent" matTooltip="Add to screen" mat-icon-button class="m-r-10" (click)="installPwa()">
    <mat-icon>add_box</mat-icon>
</button>
<button [matMenuTriggerFor]="share" mat-icon-button class="m-r-10">
    <mat-icon>share</mat-icon>
</button>
<mat-menu #share="matMenu" class="mymessage">
    <div class="mailbox">
        <ul>
            <li>
                <div class="message-center" style="height: inherit;">
                    <perfect-scrollbar [config]="config">
                        <!-- Message -->
                        <a (click)="social.onClick()" *ngFor="let social of socialSites">
                            <div class="user-img">
                                <mat-icon>{{social.icon}}</mat-icon>
                                <!-- <img src="{{social.icon}}" alt="user" class="img-circle" width="40"> -->
                            </div>
                            <div class="mail-content">
                                <h5>{{social.name}}</h5>
                            </div>
                        </a>
                        <!-- Message -->
                    </perfect-scrollbar>
                </div>
            </li>
        </ul>
    </div>
</mat-menu>
<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
<button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5">
    <img src="{{imgUrl}}users/1.jpg" alt="user" class="profile-pic"> </button>
<mat-menu #profile="matMenu" class="mymegamenu">
    <!-- <button mat-menu-item>
        <mat-icon>settings</mat-icon> Settings </button>
    <button mat-menu-item>
        <mat-icon>account_box</mat-icon> Profile </button> -->
    <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon> Sign Out </button>
</mat-menu>